// @ts-check
import React, { useEffect, useState } from 'react'
import { ResendEmailFormBase } from '../ResendEmailFormBase/ResendEmailFormBase'
import { resendTokenApi } from '../api'
import { useTranslation } from 'react-i18next'
import { usePrevious } from '../utils/hooks'
import styles from './style.css'

const ResendEmailError = () => {
  const { t, i18n } = useTranslation()
  const [isLoadingResend, setIsLoadingResend] = useState(false)
  const [sentMessage, setSentMessage] = useState('')
  const [shouldTranslateMessage, setShouldTranslateMessage] = useState(false)
  const prevLanguage = usePrevious(i18n.language)

  useEffect(() => {
    if (i18n.language === prevLanguage) return
    if (shouldTranslateMessage) {
      setSentMessage(t('createAccount.checkEmailP1Mt4'))
    }
  }, [i18n.language, shouldTranslateMessage])

  const resendToken = (email) => () => {
    setIsLoadingResend(true)
    const reject = ({ message }) => {
      setIsLoadingResend(false)
      setSentMessage(message)
    }

    const resolve = () => {
      setIsLoadingResend(false)
      setSentMessage(t('createAccount.checkEmailP1Mt4'))
      setShouldTranslateMessage(true)
    }

    resendTokenApi(email).then(resolve, reject)
  }

  return (
    <div className={styles.resendBlock}>
      {!(sentMessage.length > 0) && (
        <>
          <span>{t('resendForm.title')}</span>
          <ResendEmailFormBase resendToken={resendToken} isLoadingResend={isLoadingResend} />
        </>
      )}
      <div className={styles.sentMessage}>{sentMessage}</div>
    </div>
  )
}

export { ResendEmailError }
